import { render, staticRenderFns } from "./RolesAndUsersTab.vue?vue&type=template&id=5b9252e1&scoped=true&"
import script from "./RolesAndUsersTab.vue?vue&type=script&lang=js&"
export * from "./RolesAndUsersTab.vue?vue&type=script&lang=js&"
import style0 from "./RolesAndUsersTab.vue?vue&type=style&index=0&id=5b9252e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9252e1",
  null
  
)

export default component.exports